<template>
  <ion-page
    ref="pageRef"
    class="page-wrapper"
    :class="h5TemplateName ? h5TemplateName : ''"
    :style="background ? getBackground(background) : ''"
  >
    <ion-header>
      <div
        class="navbar"
        :class="h5TemplateName ? h5TemplateName : ''"
        :style="background ? 'color:#ffffff' : ''"
      >
        <img
          v-if="h5TemplateName || background"
          class="nav-icon"
          :src="getBrandImageUrl('back_white.png')"
          alt=""
          @click="finishedStudy"
        />
        <img
          v-else
          class="nav-icon"
          :src="getBrandImageUrl('xiaoyu.png')"
          alt=""
          @click="finishedStudy"
        />
        <span class="page-title"> {{ pageTitle }}</span>
        <img
          v-if="pageId"
          class="nav-icon right"
          :src="getBrandImageUrl('tmp_save.png')"
          alt="保存进度"
          @click="finishedStudy('save')"
        />
      </div>
    </ion-header>
    <div class="content-wrapper">
      <div class="inner-wrapper">
        <div v-show="loading" class="loading-wrapper">
          <ion-thumbnail slot="start">
            <ion-skeleton-text :animated="true"></ion-skeleton-text>
          </ion-thumbnail>
          <p v-for="item in 12" :key="item">
            <ion-skeleton-text :animated="true"></ion-skeleton-text>
          </p>
        </div>
        <!--   内容   -->
        <!-- 上一页 || 下一页 -->
        <div v-show="!loading && pageNum >= 1" id="contentWrapper-cover">
          <div ref="contentWrapperCoverRef" class="contentWrapper-cover_inner"></div>
        </div>
        <!-- 当前页 -->
        <div v-show="!loading" id="contentWrapper" ref="contentWrapperRef"></div>

        <audio id="audioPlay" ref="audioPlayRef" :src="audioPath">播放单词</audio>
        <audio id="audioPlay" ref="audioPlaySentenceRef" :src="audioSentencePath">播放句子</audio>

        <!--    图片预览    -->
        <photo-provider
          ref="photoProviderRef"
          :photo-closable="true"
          :default-backdrop-opacity="0.6"
          :download-method="downloadIamge"
        >
          <photo-consumer :src="previewImgSrc">
            <img :src="previewImgSrc" style="display: none" />
          </photo-consumer>
        </photo-provider>
      </div>
    </div>
    <ion-footer class="ion-footer">
      <div class="pagination-content">
        <div class="pagination">
          <img
            src="@/assets/icon-page-prev.png"
            class="icon-page"
            :class="{ disabled: pageNum <= 1 }"
            alt=""
            @click="handlePrevPage()"
          />
          <div>
            <span v-if="total" class="color-green">{{ pageNum }}</span>
            <span>/</span>
            <span>{{ total }}</span>
          </div>
          <img
            v-if="pageNum < total"
            src="@/assets/icon-page-next.png"
            class="icon-page"
            alt=""
            @click="handlenextPage()"
          />
          <img
            v-if="pageNum === total"
            src="@/assets/icon-page-exit.png"
            class="icon-page"
            alt=""
            @click="endStudy()"
          />
        </div>
      </div>
      <!--    底部    -->
      <div class="bottom-img">
        <img :src="brandImages.bottom_watermark" alt="" />
      </div>
    </ion-footer>
    <ion-popover
      :is-open="popoverOpen"
      :event="targetEvent"
      :show-backdrop="false"
      @didDismiss="popoverOpen = false"
    >
      <ion-content class="ion-padding">{{ targetValue }}</ion-content>
    </ion-popover>
  </ion-page>
</template>

<script>
import {
  actionSheetController,
  IonContent,
  IonFooter,
  IonHeader,
  IonPage,
  IonSkeletonText,
  IonThumbnail,
  modalController,
  popoverController,
} from "@ionic/vue";
import config from "@/js/config";
import { BRAND_IMAGES, getBrandImageUrl } from "@/js/brandImages";
import { ClickEventHandler } from "@/views/grammar/js/H5CodeClickEventHandler";
import GrammarPopover from "@/views/grammar/GrammarPopover.vue";
import { debounce } from "lodash";
import PageDialog from "@/components/PageDialog.vue";
import translateIcon from "../../../public/images/translate_icon.svg";
import grammarPlayIcon from "../../../public/images/grammar_play.png";
import audioPause from "../../../public/images/audio_pause.png";
import audioPlaying1 from "../../../public/images/audio_playing1.png";
import audioPlaying2 from "../../../public/images/audio_playing2.png";
import editPen from "../../../public/images/icon-pen.png";
import eyeOffIcon from "../../../public/images/icon-eye-off.png";
import eyeOnIcon from "../../../public/images/icon-eye-on.png";
import { textToPlayAudio } from "@/js/textToPlayAudio";
import getOssPlayInstance from "@/js/ossPlay";

export default {
  name: "GrammarPage",
  components: {
    IonPage,
    IonHeader,
    IonContent,
    IonFooter,
    IonSkeletonText,
    IonThumbnail,
  },
  props: ["courseId", "chapterId", "chapter"],
  data() {
    return {
      queryForm: {},
      dataForm: {},
      pageTitle: undefined,
      h5TemplateName: "",
      loading: true,
      regx: /((click)(#[\da-fA-F]{6})?)?(,(show_)?(ssm\w+)(#[\da-fA-F]{6})?)/g,
      pageList: [],
      background: null,
      pageNum: 1,
      total: 0,
      pageId: null,
      audioPath: null,
      audioSentencePath: null,
      playAudioStatus: false,
      playAudoImgDom: null,
      imgHttp: "https://ydl-static.oss-cn-hangzhou.aliyuncs.com/oem/images/oracy/img/",
      previewImgSrc: "",
      popoverDebounce: null,
      popoverOpen: false,
      targetEvent: null,
      targetValue: "",
      fullPhoneticRegex: /\[[a-zA-Z0-9ːəɪʊeɔɒʌæɑɜɡˈˌ-]+\]/,
      volcabularyRegx: /^\s*[a-zA-Z]+(?:[-'’.a-zA-Z0-9_]*[a-zA-Z0-9_]*)?\s*$/,
      punctuationRegx: /[\u4e00-\u9fa5]|[^\w'-]/gi, //包含中文、特殊字符
      timeout: false,
      audioTimer: null,
      audioStatus: null,
      fullTextIndex: 0,
      audioIconIndex: null,
      brandImages: BRAND_IMAGES,
      audioInstance: null,
    };
  },

  mounted() {
    this.getGrammarPagesForStudy();
    this.$refs.pageRef.$el.addEventListener("click", (ev) => {
      //控制眼睛图标
      if (ev.target.hasAttribute("icon-state")) {
        let state = ev.target.getAttribute("icon-state") === "off" ? "on" : "off";
        ev.target.setAttribute("icon-state", state);
        ev.target.src = state === "off" ? eyeOffIcon : eyeOnIcon;
      }
      this.initClickEvent(ev);
    });
    this.watchPlayEnded();

    this.popoverDebounce = debounce((ev) => {
      this.initMouseoverEvent(ev);
    }, 800);
    this.$refs.pageRef.$el.addEventListener("mousemove", this.popoverDebounce);

    const u = navigator.userAgent,
      isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
      isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
    console.log(isiOS, isAndroid);
  },

  beforeUnmount() {
    if (popoverController) {
      popoverController.dismiss();
    }
    if (this.$refs.pageRef.$el) {
      this.$refs.pageRef.$el.removeEventListener("mousemove");
      this.$refs.pageRef.$el.removeEventListener("click");
      this.popoverDebounce.cancel();
    }
    this.resetTargetEvent();
    this.audioStop();
  },

  methods: {
    getBrandImageUrl,

    audioStop() {
      if (this.audioSentencePath) {
        this.$refs.audioPlayRef.pause();
      }
      window.clearInterval(this.audioTimer);
      this.audioSentencePath = null;
      this.fullTextIndex = 0;
      this.audioStatus = null;
      this.audioTimer = null;
    },
    resetTargetEvent() {
      this.popoverOpen = false;
      this.targetEvent = null;
      this.targetValue = "";
    },

    downloadIamge() {
      const a = document.createElement("a");
      a.href = this.previewImgSrc;
      a.download = this.previewImgSrc;
      a.click();
      a.remove();
    },

    async showPopover(event, content, word) {
      // 获取窗口高度
      const windowHeight = window.innerHeight;
      const popover = await popoverController.create({
        component: GrammarPopover,
        componentProps: {
          sentence: content,
          gptStr: "",
          word: word,
        },
        event: event,
        align: "center",
        reference: "event",
        showBackdrop: false,
        side: windowHeight - event.clientY > windowHeight / 2 ? "bottom" : "top",
        alignment: "end",
        size: "auto", // 保持自动大小
        cssClass: "grammar-popover", // 使用更标准的类名格式
      });
      await popover.present();
    },

    initMouseoverEvent(ev) {
      const $wordPopover = Array.from(document.getElementsByClassName("word-popover"));
      if ($wordPopover.length >= 1) {
        return;
      }
      let $elTarget = ev.target;
      if ($elTarget.localName !== "label") {
        return;
      }
      //播放单词音频
      if ($elTarget.innerText && !$elTarget.innerText.includes(".")) {
        const text = $elTarget.innerText.replace(this.punctuationRegx, ""); //去掉特殊字符，/ 等
        if (this.volcabularyRegx.test(text)) {
          this.mousemoveAudioPlay(ev, text);
        }
      }
    },

    mousemoveAudioPlay(ev, text) {
      const { word, orgin_word, firstLetter } = this.processWord(text, ev.target);
      this.showPopover(ev, orgin_word, word);
    },

    initClickEvent(ev) {
      let $elTarget = ev.target;

      //是否为音标
      if (this.fullPhoneticRegex.test($elTarget.innerText)) {
        return false;
      }

      //播放单词音频
      if (
        $elTarget.innerText &&
        $elTarget.localName === "label" &&
        !$elTarget.innerText.includes(".")
      ) {
        const text = $elTarget.innerText.replace(this.punctuationRegx, ""); //去掉特殊字符，/ 等
        if (this.volcabularyRegx.test(text)) {
          this.playWordAudio(ev, text);
        }
      }

      //自定义点击事件
      if ($elTarget.hasAttribute("ssm")) {
        this.handleClickSSMEvent(ev);
      } else if (!$elTarget.hasAttribute("ssm") && $elTarget.parentNode.hasAttribute("ssm")) {
        //适配点击按钮上面的文字
        $elTarget.parentNode.click();
      } else if (
        !$elTarget.hasAttribute("ssm") &&
        $elTarget.tagName === "LABEL" &&
        $elTarget.parentNode.parentNode.hasAttribute("ssm")
      ) {
        //适配按钮单词被label标签包裹
        $elTarget.parentNode.parentNode.click();
      }

      //点击播放听力音频
      if ($elTarget.hasAttribute("data-audio")) {
        this.playListeningAudio(ev);
      }

      //图片预览
      if ($elTarget.hasAttribute("data-preview")) {
        this.previewImgSrc = $elTarget.src;
        this.$refs.photoProviderRef.visible = true;
      }

      //写作填空
      if (
        $elTarget.hasAttribute("ssm-answer") ||
        $elTarget.parentElement.hasAttribute("ssm-answer")
      ) {
        let currentEle = $elTarget.hasAttribute("ssm-answer")
          ? $elTarget
          : $elTarget.parentElement.hasAttribute("ssm-answer")
            ? $elTarget.parentElement
            : null;
        const answer = currentEle.getAttribute("ssm-answer");
        const style = "color:#FFAD00;text-decoration:underline";
        const result = this.handleSplitWord(answer, true);
        currentEle.innerHTML = `<span style=${style}>${result}</span>`;
      }

      //翻译图标
      if ($elTarget.id === "translateSentenceIcon") {
        this.popoverOpen = true;
        this.targetEvent = ev;
        this.targetValue = $elTarget.getAttribute("data-translate");
      }

      //播放图标
      if ($elTarget.id === "AudioSentenceIcon") {
        const parentElement = $elTarget.parentElement;
        const sentenceList =
          parentElement.parentElement.querySelectorAll("#paragraphList")[0].childNodes;
        const audioSentenceIconArr = document.querySelectorAll("#AudioSentenceIcon");
        audioSentenceIconArr.forEach((el) => {
          el.src = grammarPlayIcon;
        });
        window.clearInterval(this.audioTimer);
        this.audioTimer = null;

        if ($elTarget.getAttribute("data-index") !== this.audioIconIndex) {
          this.audioStatus = null;
          this.$refs.audioPlaySentenceRef.pause();
          this.audioSentencePath = null;
          this.fullTextIndex = 0;
        }

        this.audioIconIndex = $elTarget.getAttribute("data-index");
        this.fullTextAudioPlay(sentenceList, $elTarget);
      }

      //页面目录跳转
      if ($elTarget.hasAttribute("data-redirectId")) {
        const pageId = $elTarget.getAttribute("data-redirectId");
        this.pageList.map((item, index) => {
          item.pageNum = index + 1;
          if (pageId == item.pageId) {
            this.pageId = pageId;
            this.pageNum = item.pageNum;
            this.initTemplateData(item);
          }
        });
      }
    },

    /**
     * 分割单词
     * single ：验证单字母
     * */
    handleSplitWord(html, single = true) {
      const result = html
        .split(/(<[^>]+>)/)
        .map((item, index) => {
          if (/<[^>]+>/.test(item)) {
            return item;
          } else {
            const validWord = !single
              ? /[a-zA-Z]+/.test(item) && !/([A-Z]){1}$/.test(item)
              : /[a-zA-Z]+/.test(item);
            if (validWord) {
              // 支持撇号和连字符的单词，如 doesn't、thirty-thirty
              let splitWordArray = item.split(/([a-zA-Z]+(?:['’-][a-zA-Z]+)*)/).map((word) => {
                if (word && /^[a-zA-Z]+(?:['’-][a-zA-Z]+)*$/.test(word)) {
                  return `<label>${word}</label>`;
                } else {
                  return word;
                }
              });
              return splitWordArray.join("");
            } else {
              return item;
            }
          }
        })
        .join("");
      return result;
    },

    /* 根据标签title释义句末添加《译》图标并翻译 */
    initTranslateSentence(resource) {
      const dom = document.createElement("div");
      dom.style = "width: 100%; height: 100%";
      dom.innerHTML = resource;

      // 段落 & 句子播放
      let paragraphDom =
        dom.querySelectorAll("#ai-sentence-paragraph").length === 0
          ? dom.querySelectorAll(".ai-sentence-paragraph")
          : dom.querySelectorAll("#ai-sentence-paragraph");
      const ssm_aisentence_paragraph = dom.querySelectorAll(".ssmai-sentence-paragraph");
      paragraphDom = Array.from(paragraphDom).concat(Array.from(ssm_aisentence_paragraph));
      paragraphDom.forEach((paragraph) => {
        const imgDom = document.createElement("img");
        imgDom.src = grammarPlayIcon;
        imgDom.id = "AudioSentenceIcon";
        imgDom.style =
          "width:40px;height:40px;vertical-align:middle;margin-left:10px;cursor:pointer;display: inline-block;";
        const sentenceList = paragraph.querySelectorAll("#ai-single-sentence");
        sentenceList.forEach((s) => {
          s.style.display = "inline";
        });
        paragraph.append(imgDom);
      });

      //查找________ 🖋并替换
      const texts = dom.querySelectorAll("[ssm-answer]");
      const newText = `<span style="color: #FFAD00;">________ <img src="${editPen}" style="width: 1rem;height: 1rem"/></span>`;
      texts.forEach((t) => {
        t.innerHTML = newText;
      });

      //查找段落并添加眼睛图标
      const translateArr = dom.querySelectorAll(".ssm-translate");
      translateArr.forEach((item, index) => {
        const img = document.createElement("img");
        img.src = eyeOffIcon;
        img.class = "icon-eye";
        img.style =
          "width: 1.2rem;height: 1.2rem;position: relative; vertical-align: middle;margin-left: 0.3rem;";
        img.setAttribute("icon-state", "off");
        img.setAttribute("ssm", `click,show_ssmtranslate${index}`);
        item.appendChild(img);
      });

      //添加《译》图标
      const hasTitleDom = dom.querySelectorAll("[title]");
      hasTitleDom.forEach((item) => {
        const imgDom = document.createElement("img");
        imgDom.src = translateIcon;
        imgDom.id = "translateSentenceIcon";
        imgDom.style =
          "width:50px;height:50px;vertical-align:middle;margin-left:10px;cursor:pointer;";
        imgDom.setAttribute("data-translate", item.getAttribute("title"));
        item.removeAttribute("title");
        const $aiSentenceParagraph = item.querySelector("#ai-sentence-paragraph");
        if ($aiSentenceParagraph) {
          $aiSentenceParagraph.appendChild(imgDom);
        } else {
          item.appendChild(imgDom);
        }
      });

      return dom.outerHTML;
    },

    fullTextAudioPlay(sentenceList, audioDom) {
      if (sentenceList.length > 0) {
        let num = 0;

        const paragraphAudioPlay = () => {
          const dom = sentenceList[this.fullTextIndex];
          let text = dom.outerText;
          const that = this;

          if (that.audioStatus !== "playing") {
            textToPlayAudio(text.trim(), (url) => {
              if (!that.audioSentencePath) {
                that.audioSentencePath = url;
                that.$refs.audioPlaySentenceRef.oncanplay = function () {
                  that.$refs.audioPlaySentenceRef.play();
                };
              } else {
                that.$refs.audioPlaySentenceRef.play();
              }
              audioDom.src = audioPlaying1;
              if (!that.audioTimer) {
                that.audioTimer = setInterval(() => {
                  audioDom.src = ++num % 2 ? audioPlaying1 : audioPlaying2;
                }, 300);
              }

              that.$refs.audioPlaySentenceRef.onplaying = function () {
                that.audioStatus = "playing";
              };
              that.$refs.audioPlaySentenceRef.onended = function () {
                that.audioStatus = "ended";
                if (that.fullTextIndex === sentenceList.length - 1) {
                  that.audioIconIndex = null;
                  window.clearInterval(that.audioTimer);
                  that.audioTimer = null;
                  audioDom.src = grammarPlayIcon;
                  that.audioSentencePath = null;
                  that.fullTextIndex = 0;
                } else {
                  that.audioSentencePath = null;
                  that.fullTextIndex += 1;
                  paragraphAudioPlay();
                }
              };
            });
          } else if (that.audioStatus === "playing") {
            that.audioStatus = "paused";
            audioDom.src = audioPause;
            that.$refs.audioPlaySentenceRef.pause();
          }
        };
        paragraphAudioPlay();
      }
    },

    //播放听力音频
    playListeningAudio(ev) {
      const playSrc = `${this.imgHttp}播放.png`; //播放图片
      const pauseSrc = `${this.imgHttp}暂停.png`; //暂停图片
      const speedSrc = `${this.imgHttp}下一播放.png`;
      const audio = ev.target.getAttribute("data-audio");
      const elSrc = decodeURIComponent(ev.target.src);

      //判断是否是倍速播放图片，是则设置ssm-playbackrate属性
      if (elSrc === speedSrc) {
        ev.target.setAttribute("ssm-playbackrate", 1);
      }
      //初始化音频播放器
      if (
        this.audioPath &&
        this.playAudoImgDom &&
        (this.audioPath !== audio || this.playAudoImgDom !== ev.target)
      ) {
        this.$refs.audioPlayRef.load();
        this.playAudioStatus = false;
        this.playAudoImgDom.src = this.playAudoImgDom.getAttribute("ssm-playbackrate")
          ? speedSrc
          : playSrc;
      }

      this.playAudoImgDom = ev.target;
      this.audioPath = audio;

      if (!this.playAudioStatus) {
        const playAudio = () => {
          this.$refs.audioPlayRef.play();
          this.playAudioStatus = true;
          this.playAudoImgDom.src = pauseSrc;
        };
        setTimeout(playAudio, 100);
      } else {
        this.$refs.audioPlayRef.pause();
        this.playAudioStatus = false;
        this.playAudoImgDom.src = this.playAudoImgDom.getAttribute("ssm-playbackrate")
          ? speedSrc
          : playSrc;
      }
    },

    //替换特殊字符
    replaceSpecialSymbol(text) {
      //return text.replace(/[^\w\s]/gi, "")
      return text;
    },

    //根据单词被分割的情况，拼接完整单词
    processWord(text, targetElement) {
      const parent =
        targetElement.tagName === "LABEL" ? targetElement.parentElement : targetElement;
      const parentInnerText = parent.innerText;
      const previousSiblingInnerText = parent.previousSibling?.innerText;
      const nextChildInnerText = parent.nextSibling?.innerText;
      const beginRegx = /^\s|^\W/; //单词是否以空格或者非词开头
      const endRegx = /\s$/; //单词是否以空格结尾
      let w = text.replace(this.punctuationRegx, "");
      const regx = eval(`/\\s(${w})/`);
      const previousEnd = endRegx.test(previousSiblingInnerText);
      const nextBegin = beginRegx.test(nextChildInnerText);

      if (nextChildInnerText && !previousSiblingInnerText) {
        console.log(1);
        if (!endRegx.test(parentInnerText)) {
          w = w + nextChildInnerText.split(this.punctuationRegx)[0];
        }
      }

      if (previousSiblingInnerText && !nextChildInnerText) {
        console.log(2);
        if (!regx.test(parentInnerText)) {
          const arr = previousSiblingInnerText.split(this.punctuationRegx);
          w = arr[arr.length - 1] + w;
        }
      }

      if (nextChildInnerText && previousSiblingInnerText) {
        if (!previousEnd && nextBegin) {
          console.log("3-1");
          const arr = previousSiblingInnerText.split(this.punctuationRegx);
          w = arr[arr.length - 1] + w;
        }
        if (previousEnd && !nextBegin) {
          console.log("3-2");
          if (
            beginRegx.test(parentInnerText) ||
            (!beginRegx.test(parentInnerText) && !endRegx.test(parentInnerText))
          ) {
            w = w + nextChildInnerText.split(this.punctuationRegx)[0];
          }
        }
        if (!previousEnd && !nextBegin) {
          console.log("3-3");
          if (!beginRegx.test(parentInnerText) && endRegx.test(parentInnerText)) {
            if (!regx.test(parentInnerText)) {
              const arr = previousSiblingInnerText.split(this.punctuationRegx);
              w = arr[arr.length - 1] + w;
            }
          } else if (beginRegx.test(parentInnerText) && !endRegx.test(parentInnerText)) {
            if (!regx.test(parentInnerText)) {
              w = w + nextChildInnerText.split(this.punctuationRegx)[0];
            }
          }
        }
      }

      const orgin_word = w;
      const word = w.toLowerCase(); //播放音频接口需要单词小写
      const firstLetter = w.toLowerCase().charAt(0);
      return { word, orgin_word, firstLetter };
    },

    //是否有特殊字符
    trimAll(str) {
      if (typeof str === "string") {
        let result = str.split(/[\t\r\f\n\s.]*/g).join("");
        return result ? true : false;
      } else {
        console.log(`${typeof str} is not a string`);
      }
    },

    //播放单词音频
    playWordAudio(ev, text) {
      const { word, firstLetter } = this.processWord(text, ev.target);
      //播放器正在播放时，不执行
      // if (!this.$refs.audioPlayRef.paused) {
      //   return false;
      // }

      // this.audioPath = `https://ydl-static.oss-cn-hangzhou.aliyuncs.com/audio/type2/${firstLetter}/${word}.mp3`;
      //
      // if (!this.playAudioStatus) {
      //   this.$nextTick(() => {
      //     this.$refs.audioPlayRef
      //       .play()
      //       .then(() => {
      //         this.playAudioStatus = true;
      //       })
      //       .catch((error) => {
      //         this.$refs.audioPlayRef.load();
      //         this.playAudioStatus = false;
      //       });
      //   });
      // } else {
      //   this.$nextTick(() => {
      //     this.$refs.audioPlayRef.load();
      //     this.playAudioStatus = false;
      //   });
      // }
      if (this.audioInstance && this.audioInstance.loading) {
        return false;
      }
      this.audioInstance = getOssPlayInstance().init({ msg: word });
      this.audioInstance.play();
    },

    //是否大写
    isUpperCase(char) {
      let charCode = char.charCodeAt(0);
      return charCode >= 65 && charCode <= 90;
    },
    //监听播放结束
    watchPlayEnded() {
      this.$nextTick(() => {
        this.$refs.audioPlayRef.addEventListener("ended", (ev) => {
          if (ev.target.ended) {
            const playSrc = `${this.imgHttp}播放.png`; //播放图片
            const speedSrc = `${this.imgHttp}下一播放.png`;
            this.$refs.audioPlayRef.load();
            this.playAudioStatus = false;
            if (this.playAudoImgDom) {
              this.playAudoImgDom.src = this.playAudoImgDom.getAttribute("ssm-playbackrate")
                ? speedSrc
                : playSrc;
            }
          }
        });
      });
    },
    //上一页
    handlePrevPage() {
      if (this.pageNum <= 1) {
        return;
      }
      this.pageNum = this.pageNum - 1;
      this.pageList.map((item) => {
        if (item.pageNum === this.pageNum) {
          console.log("当前页：", item.pageId);
          this.audioPath = null;
          this.audioSentencePath = null;
          this.initTemplateData(item, "preview");
        }
      });
    },
    //下一页
    handlenextPage() {
      if (this.pageNum + 1 > this.total) {
        return false;
      }
      this.pageNum = this.pageNum + 1;
      this.pageList.map((item) => {
        if (item.pageNum === this.pageNum) {
          console.log("当前页：", item.pageId);
          this.audioPath = null;
          this.audioSentencePath = null;
          this.initTemplateData(item, "next"); // 当前页动效翻页
        }
      });
    },
    //保存进度
    finishedStudy(flag) {
      this.audioStop();
      let aptmId = this.store.getAppointment().aptmId;
      let dataForm = {
        page: this.pageNum,
        pageId: this.pageId,
        chapterId: this.chapterId,
        finished: 1,
        aptmId: aptmId,
        studentId: this.store.getAppointment().studentId,
      };
      this.ajax
        .post("/grammar/endGrammarStudy", dataForm)
        .then((res) => {
          if (res.data.success) {
            this.onClose();
          }
        })
        .finally(() => {
          popoverController.dismiss();
        });
      this.resetTargetEvent();
    },

    // 保存进度并创建抗遗忘
    async openConfirmModal() {
      const modal = await modalController.create({
        id: "PageDialog",
        component: PageDialog,
        componentProps: { title: "", message: "是否创建抗遗忘？", type: "hasCancel" },
        cssClass: "center_modal_controller_class3",
        backdropDismiss: false,
      });
      await modal.present().then(() => {});
      modal.onDidDismiss().then(({ data }) => {
        if (data === "NEXT") {
          let aptmId = this.store.getAppointment().aptmId;
          this.showTeacherSelect(aptmId);
        } else {
          this.onClose();
        }
      });
    },

    requestGenerateForget(params) {
      return new Promise((resolve, reject) => {
        if (!this.timeout) {
          this.timeout = true;
          setTimeout(() => {
            this.timeout = false;
          }, 500);
          if (params.aptmId == 0) {
            resolve("");
          } else {
            this.ajax
              .post("/forget/generateForget", params)
              .then(async (res) => {
                if (res.data.success) {
                  await this.alert("21天抗遗忘创建成功。");
                  resolve("");
                }
              })
              .catch(() => {
                reject("");
              });
          }
        }
      });
    },

    //显示选择资料列表
    async showTeacherSelect(aptmId) {
      return new Promise(async (resolve) => {
        let buttons = [];
        for (let i = 5; i < 24; i++) {
          let fill = i < 10 ? "0" : "";
          let time1 = fill + i + ":00";
          let time2 = fill + i + ":30";
          let params1 = { aptmId: aptmId, startTime: time1 };
          let params2 = { aptmId: aptmId, startTime: time2 };
          buttons.push({
            text: time1,
            handler: async () => {
              await this.requestGenerateForget(params1);
              this.onClose();
              resolve();
            },
          });

          buttons.push({
            text: time2,
            cssClass: "teacherSelectButtons",
            handler: async () => {
              await this.requestGenerateForget(params2);
              this.onClose();
              resolve();
            },
          });
        }
        const actionSheet = await actionSheetController.create({
          header: "选择抗遗忘时间 ",
          buttons: buttons,
          backdropDismiss: false,
        });

        await actionSheet.present();
      });
    },

    //退出
    endStudy() {
      let aptmId = this.store.getAppointment().aptmId;
      let dataForm = {
        page: this.pageNum,
        pageId: this.pageId,
        chapterId: this.chapterId,
        finished: undefined,
        aptmId: aptmId,
        studentId: this.store.getAppointment().studentId,
      };
      this.ajax.post("/grammar/endGrammarStudy", dataForm).then((res) => {
        if (res.data.success) {
          this.openConfirmModal();
        }
      });
    },

    async getGrammarPagesForStudy() {
      let aptmId = this.store.getAppointment().aptmId;
      this.queryForm = {
        studentId: this.store.getAppointment().studentId,
        courseId: this.courseId,
        chapterId: this.chapterId,
        aptmId: aptmId,
      };
      this.ajax
        .post("/grammar/getGrammarPagesForStudy", this.queryForm)
        .then((res) => {
          if (res.data.success) {
            let { data, pageId, title, list } = res.data;
            let currentPageData = data;
            this.pageId = currentPageData.pageId;
            this.pageTitle = title;
            this.pageList = list;
            this.pageList.map((item, index) => {
              item.pageNum = index + 1;
              if (this.pageId === item.pageId) {
                currentPageData.pageNum = item.pageNum;
              }
            });
            this.total = this.pageList.length;
            this.pageNum = currentPageData.pageNum;
            this.initTemplateData(currentPageData, "init");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    initTemplateData(data, pageType) {
      this.audioStop();
      this.pageId = data.pageId;

      //初始化音频播放器
      this.$refs.audioPlayRef.load();
      this.playAudioStatus = false;
      this.playAudoImgDom = null;

      switch (data.resourceType) {
        case "RESOURCE_TYPE_CODE": //H5源码
          this.background = null;
          this.getH5CodeAndAnalyze(data, pageType);
          break;
        case "RESOURCE_TYPE_DOC":
          this.h5TemplateName = null;
          this.background = data.background;
          this.previewDoc(data);
          break;
        /*        case "RESOURCE_TYPE_VIDEO":
                      this.h5TemplateName = null;
                      this.background = data.background;
                      this.previewDoc(data)
                      break;
                    case "RESOURCE_TYPE_AUDIO":
                      this.h5TemplateName = null;
                      this.background = data.background;
                      this.previewDoc(data)
                      break;*/
      }
    },

    getBackground(val) {
      let result;
      let regx = /#[\da-fA-F]{6}/;
      if (regx.test(val)) {
        result = `background:${val}`;
      } else {
        result = `background-image:url(${val});background-size:100% 100%`;
      }
      return result;
    },

    async previewDoc(data) {
      let src =
        config.config.API_ADDRESS +
        "/grammar/previewDocumentation?fileName=" +
        data.resourceFilename;
      let $contentWrapper = document.getElementById("contentWrapper");
      $contentWrapper.innerHTML = "";
      let iframe = document.createElement("iframe");
      $contentWrapper.append(iframe);
      iframe.style.width = "100%";
      iframe.style.height = "95%";
      iframe.style.border = "none";
      iframe.src = src;
      /*this.ajax.get('/grammar/previewDocumentation?fileName='+data.resourceFilename).then(res=>{
        if(res.data.code === 200){
          let src =  res.data.data;
          let $contentWrapper = document.getElementById("contentWrapper");
          $contentWrapper.innerHTML = "";
          let iframe = document.createElement("iframe");
          $contentWrapper.append(iframe)
          iframe.style.width = "100%";
          iframe.style.height = "95%";
          iframe.style.border = "none";
          iframe.src = config.config.API_ADDRESS + src;
          console.log( config.config.API_ADDRESS + src);
        }
      })*/
    },

    async handleClickSSMEvent(ev) {
      const clickEvent = new ClickEventHandler();
      clickEvent.handleClick(ev);
    },

    //获取H5源码并解析
    async getH5CodeAndAnalyze(data, pageType) {
      const oldPage = this.$refs.contentWrapperRef.innerHTML;
      const pageDom = this.$refs.contentWrapperRef;
      const resource = this.handleSplitWord(data.resource);
      const transSentenceResource = this.initTranslateSentence(resource);
      const newResource = this.pxRechargeRem(transSentenceResource);
      this.h5TemplateName = data.h5TemplateName;

      // 使用 innerHTML 时需要注意防范 XSS 攻击，确保资源是安全的
      pageDom.innerHTML = this.filterUnsafeHtml(newResource);

      const ssmElements = document.querySelectorAll("[ssm]");
      for (const item of ssmElements) {
        await this.handleHideDom(item);
      }

      this.$refs.contentWrapperCoverRef.innerHTML = oldPage;
      this.$refs.contentWrapperRef.style.display = "none";

      await this.$nextTick(() => {
        this.$refs.contentWrapperRef.style.animation = "none";
        setTimeout(() => {
          pageDom.style.display = "inline-flex";
          if (pageType === "next") {
            this.$refs.contentWrapperRef.style.animation = "next-animation 0.5s ease-in-out";
          } else if (pageType === "preview") {
            this.$refs.contentWrapperRef.style.animation = "preview-animation 0.5s ease-in-out";
          } else if (pageType === "init") {
          } else {
            pageDom.style.animation = "none 0 ease 0 1 normal";
          }
        }, 1);

        //为每一页的播放图标加上唯一标识，方便页面存在多个播放图标时进行条件判断
        const $AudioSentenceIconList = document.querySelectorAll("#AudioSentenceIcon");
        $AudioSentenceIconList.forEach((item, index) => {
          item.setAttribute("data-index", index);
        });

        //初始化class名为.ssmcolor-yellow的元素字体颜色
        const yellowColorArry = document.querySelectorAll(".ssmcolor-yellow");
        yellowColorArry.forEach((item) => {
          item.classList.add("color-gary");
        });
      });
    },
    //过滤不安全的html标签和属性
    filterUnsafeHtml(html) {
      if (!html) {
        return "";
      }
      return html.replace(/<script.*?>.*?<\/script>/gi, "");
    },
    //匹配模板代码片段style中的px单位转换为rem
    pxRechargeRem(html) {
      if (!html) {
        return "";
      }
      let pxRegx = /(\d+)(px)/g;
      let rootValue = 33;
      return html.replace(pxRegx, (str, p1) => {
        if (Number(p1) <= 1) {
          return `${p1}px`;
        } else {
          let rem = this.toFixed(Number(p1 / rootValue), 2);
          return `${rem}rem`;
        }
      });
    },
    //保留两位小数不要四舍五入
    toFixed(num, decimal) {
      let result = +`${num}e${decimal}`;
      result <<= 0;
      result = +`${result}e${-decimal}`;
      return result;
    },

    //显示/隐藏含有show_属性值的元素
    handleHideDom(ev) {
      if (this.regx.test(ev.outerHTML)) {
        this.regx.lastIndex = 0;
        ev.outerHTML.match(this.regx).map((result) => {
          this.regx.lastIndex = 0;
          let execArr = this.regx.exec(result);
          let isShow = execArr[5] ? true : false;
          let className = execArr[6];
          if (isShow) {
            Array.from(document.getElementsByClassName(className)).forEach((item) => {
              item.style.visibility = "hidden";
              this.regx.lastIndex = 0;
            });
          }
        });
      }
    },
  },
};
</script>

<style scoped>
@import "@/theme/template.less";

.navbar {
  font-size: 18px;
}

ion-toolbar {
  /* --background: #645fa9; */
  --padding: 0;
  --margin: 0;
  --border: none;
}

.page-wrapper {
  width: 100%;
  height: 100%;
}

.content-wrapper {
  height: calc(100% - 120px);
  overflow: hidden;
  position: relative;

  .loading-wrapper {
    padding: 0.9rem 1rem;

    .skeleton-text-animated {
      margin: auto;
      width: 100%;
    }
  }

  .inner-wrapper {
    padding: 0.9rem 1rem;
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    position: relative;
  }

  #contentWrapper-cover {
    width: 100%;
    height: 100%;
    padding: 0.9rem 1rem;
    overflow-y: auto;
    position: absolute;
    left: 50%;
    top: 0;
    transform: translateX(-50%);
    border-radius: 0.66667rem;
    transition: transform 0.3s;
    box-sizing: border-box;
    z-index: 100;
  }

  .contentWrapper-cover_inner {
    width: 100%;
    height: 100%;
    position: relative;
    background: white;
    //padding: 0.9rem 1rem;
    box-sizing: border-box;
    border-radius: 0.66667rem;
    overflow-y: auto;
  }

  #contentWrapper {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    //padding: 0.9rem 1rem;
    position: relative;
    background: white;
    border-radius: 0.66667rem;
    transition: transform 0.3s;
    z-index: 103;
  }
}

.ion-footer {
  width: 100%;
  height: 120px;

  .pagination-content {
    display: flex;
    justify-content: flex-end;

    .pagination {
      display: inline-flex;
      justify-content: space-around;
      align-items: center;
      background: rgba(255, 255, 255, 0.2);
      min-width: 8rem;
      border-radius: 30px 0 0 30px;
      font-size: 1rem;
      color: rgba(255, 255, 255, 0.5);
      padding: 6px 10px;
      box-sizing: border-box;
    }
  }

  .icon-page {
    width: 1rem;
    height: 1rem;
  }

  .disabled {
    opacity: 0.2;
    cursor: not-allowed;
  }
}

.bottom-img {
  width: 100%;
  text-align: center;
  margin-top: 10px;

  img {
    width: 60%;
  }
}

.footer-md:before {
  display: none;
}

.navbar {
  height: 44px;
  line-height: 44px;
  text-align: center;
  position: relative;

  .page-title {
    width: 58%;
    overflow: hidden;
    display: inline-block;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .right-text {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translate(0, -50%);
    font-weight: 400;
  }
}

.nav-icon {
  width: 24px;
  height: 24px;
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translate(0, -50%);

  &.right {
    width: 22px;
    height: 22px;
    left: auto;
    right: 17px;
  }
}

ion-header::after {
  display: none;
}

ion-header {
  background: transparent;
}
</style>
<style>
#contentWrapper > div {
  min-height: 100%;
  height: auto !important;
}

#contentWrapper > div,
.contentWrapper-cover_inner > div {
  overflow-y: auto;
  display: inline-flex;
  align-items: flex-start !important;
  justify-content: center;
  padding: 0;
  box-sizing: border-box !important;
  padding-bottom: 1rem !important;
}

#contentWrapper div,
.contentWrapper-cover_inner div {
  box-sizing: content-box;
}

#contentWrapper img,
.contentWrapper-cover_inner img {
  object-fit: cover;
  width: 100%;
  //height: auto !important;
}

#audioPlay {
  display: none;
}

.color-yellow {
  color: #ffad00 !important;
}

.color-green {
  color: #17bf8a;
}

.color-gary {
  color: #3f4140 !important;
  font-weight: 400 !important;
}

.btn-gray {
  background: #f2f3f6 !important;
}

.btn-red {
  background: linear-gradient(89.66deg, #fe8846 0.25%, #fe4a46 99.67%) !important;
}

.btn-red label,
.btn-red div {
  color: white !important;
}

.btn-green {
  background: linear-gradient(90deg, #00c67c 0%, #01edb2 100%) !important;
}

.btn-green label,
.btn-green div {
  color: white !important;
}

@keyframes next-animation {
  0% {
    transform: translate3d(125vw, 0, 0) rotate(10deg);
    transform-origin: right bottom;
  }
  100% {
    transform: translate3d(0, 0, 0) rotate(0);
  }
}

@keyframes preview-animation {
  0% {
    transform: translate3d(-125vw, 0, 0) rotate(-10deg);
    transform-origin: left bottom;
  }
  100% {
    transform: translate3d(0, 0, 0) rotate(0);
  }
}

ion-popover::part(content) {
  --width: none !important;
  max-width: 100vw;
}
</style>
